import { render, staticRenderFns } from "./BannerRightSidebar.vue?vue&type=template&id=4c04278e"
import script from "./BannerRightSidebar.vue?vue&type=script&lang=js"
export * from "./BannerRightSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports